// Quiz questions, generated from `Off Campus Episodic Quiz Questions.md` (source of truth).
// Keyed by episode number (2–8); 10 questions each, 4 options, one correct.

export interface QuizQuestion {
  prompt: string;
  options: readonly string[];
  /** Index (0–3) of the correct option. */
  correctIndex: number;
}

export const QUIZ_QUESTIONS: Record<number, readonly QuizQuestion[]> = {
  2: [
    {
      prompt: 'What is “Phase 2” of Garrett’s strategy to get his and Hannah’s fake relationship on The Fifth Line?',
      options: [
        'Maintain possession of the puck',
        'Defensive zone coverage',
        'Offensive zone pressure',
        'Power play',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What heavy metal band’s T-shirt is Garrett sporting while he’s studying philosophy with Hannah?',
      options: [
        'Black Sabbath',
        'Pink Floyd',
        'Iron Maiden',
        'Metallica',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'What is Dean and Beau’s birthday party invite titled?',
      options: [
        'Maxwell Di Laurentis 2 for 1 Bday Bash!',
        'Di Laurentis Maxwell 22nd Bday Party!',
        'Dean and Beau’s 22nd Bday Rager!',
        'Twofers Rager!',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What costume does Hannah suggest for the party?',
      options: [
        'Mean Girls',
        'Heathers',
        'Beetlejuice',
        'Legally Blonde',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'How long does Garrett make Hannah wait for their tutoring session?',
      options: [
        '30 minutes',
        '45 minutes',
        '20 minutes',
        '1 hour',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What team are the Hawks playing at their first away game of the season?',
      options: [
        'The Chatham Plovers',
        'The St. Anthony Vipers',
        'The Northbridge Owls',
        'The Lakecrest Falcons',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What is Tucker dressed up as at the party?',
      options: [
        'A golden retriever',
        'A bee',
        'A butterfly',
        'A lion',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What JLo song does Allie dance to at the party?',
      options: [
        '“On The Floor”',
        '“Waiting For Tonight”',
        '“Let’s Get Loud”',
        '“Dance Again”',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What TV show is open on a tab on Hannah’s computer while she and Garrett are watching Justin’s Tiny Dorm Concert?',
      options: [
        'Game of Thrones',
        'The White Lotus',
        'Succession',
        'Breaking Bad',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'What song does Garrett listen to on the bus?',
      options: [
        '“Edge of The Earth” - The Beaches',
        'Billy Porter’s cover of “The Bitch is Back”',
        '“Blame Brett” - The Beaches',
        '“Soup” - Remi Wolf',
      ],
      correctIndex: 0,
    },
  ],
  3: [
    {
      prompt: 'How does Garrett describe Justin on the phone with Hannah?',
      options: [
        'Performative male',
        'Pretentious douche',
        'Artistic fuckboy',
        'Pompous asshole',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What does John Logan say is the ideal sponsorship?',
      options: [
        'Chicken Kitchen',
        'Burger Table',
        'Burrito House',
        'Taco Shack',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'What instrument does Hannah want featured having a “conversation” with the vocals in her song?',
      options: [
        'Cello',
        'Violin',
        'Viola',
        'Double bass',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'Where is John Logan off to when Hannah runs into him at the house?',
      options: [
        'To get his ice skates sharpened',
        'To his family’s garage to fix a motorcycle',
        'To hang Professor Walden’s new widescreen TV',
        'To Jules’ dorm to drop off something they left at the house',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What question does Justin ask Hannah right before she accidentally shows him her “Crushing” playlist?',
      options: [
        '“Can I send you this file so we can riff on it?”',
        '“Do you write your lyrics down or record them?”',
        '“Are you a Pro Tools or a Logic girl?”',
        '“Can I show you some lyrics I’ve been working on?”',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'And as Kierkegaard once said… (paraphrased)',
      options: [
        '“Once you label me, you fucking negate me”',
        '“Ghosting is the dizziness of freedom”',
        '“Life is not a problem to be solved, but a reality to be fucking experienced”',
        '“To ghost is to lose one’s footing momentarily”',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What duet does Jules say they’re going to sign Garrett and Logan up for at karaoke night?',
      options: [
        '“Shallow” from A Star Is Born',
        '“Rewrite The Stars” from The Greatest Showman',
        '“Summer Nights” from Grease',
        '“Suddenly Seymour” from Little Shop of Horrors',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What does Hannah call Phil Graham at Malone’s?',
      options: [
        'George Washed-ington',
        'Oldie McOldfuck',
        'Moldy Old Fart',
        'Grandpa Puck',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What’s written on the inside of the bathroom stall at Malone’s?',
      options: [
        'Fuck Eastwood',
        'Stupid Dean and his stupid awesome dick',
        'Go Hawks!',
        'All of the above',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'Who does NOT do karaoke at Malone’s?',
      options: [
        'Allie Hayes',
        'Hannah Wells',
        'John Tucker',
        'John Logan',
      ],
      correctIndex: 3,
    },
  ],
  4: [
    {
      prompt: 'Which of the following fruits does Tucker NOT guard during the episode?',
      options: [
        'Watermelon',
        'Kiwi',
        'Mango',
        'Banana',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What was Hannah’s favorite musical artist in middle school?',
      options: [
        'Paramore',
        'Fall Out Boy',
        'Panic! At The Disco',
        'Twenty One Pilots',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What does Tucker name the fruit he’s guarding during hockey practice?',
      options: [
        'Bernardo',
        'Benjamin',
        'Bryce',
        'Benson',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What are the five acts of Allie’s breakup cycle?',
      options: [
        'Raging Diva Allie → Eats Her Feelings Allie → Complete and Total Breakdown Allie → Late Night Phone Call Allie',
        'Eats Her Feelings Allie → Raging Diva Allie → Screaming and Crying Allie → Moving On Allie → Late Night Phone Call Allie',
        'Complete and Total Breakdown Allie → Surprise Fight Allie → Raging Diva Allie → Eats Her Feelings Allie → Late Night Phone Call Allie',
        'Surprise Fight Allie → Eats Her Feelings Allie → Raging Diva Allie → Complete and Total Breakdown Allie → Late Night Phone Call Allie',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'How much weight is Garrett struggling to lift at the gym when Dean helps him?',
      options: [
        '195 lbs',
        '200 lbs',
        '205 lbs',
        '210 lbs',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'At last year’s Drunk Shakespeare, Hamlet got so drunk that he:',
      options: [
        'Improvised falling in love with Laertes instead of Ophelia',
        'Threw up in the middle of the “To be or not to be” soliloquy',
        'Made out with the ghost of his own father',
        'All of the above',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'Hannah thinks that Garrett came to Drunk Shakespeare because:',
      options: [
        'He and Beau used to go to see Joanna perform',
        'He wanted to talk to her',
        'He loves Shakespeare',
        'Beau and Dean dragged him there',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'What does the shirt Dexter’s wearing at Drunk Shakespeare say?',
      options: [
        'Puck Off',
        'A Midsummer Night’s Scream',
        'Puck Me Baby',
        'Puck Around And Find Out',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'Which play poster is featured on the walls of the theater?',
      options: [
        'The Crucible',
        'Angels in America',
        'Hamlet',
        'All of the above',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'What is Allie’s phone home screen?',
      options: [
        'A photo of Sean',
        'A photo of herself',
        'A photo of her and Hannah',
        'A photo of her and Sean',
      ],
      correctIndex: 0,
    },
  ],
  5: [
    {
      prompt: 'What dish does Mrs. Wells suggest that Hannah bring to Friendsgiving?',
      options: [
        'Nana’s lasagna',
        'Mrs. Wells’ green bean casserole',
        'Key lime pie',
        'Mr. Wells’ sweet potato souffle',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What wrong name does Garrett use to refer to Justin after class?',
      options: [
        'Jonathan',
        'Julian',
        'Jacob',
        'Jackson',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What kind of “mean” does John Logan look in the Liquid I.V. photoshoot, according to Jules?',
      options: [
        '“Tough” mean',
        '“Jules” mean',
        '“Zdeno Chára” mean',
        '“Phil Graham” mean',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What are the garlands hanging outside of the hockey house made of?',
      options: [
        'Empty beer bottles',
        'Red solo cups',
        'Hockey tape and pucks',
        'Briar U Hawk stuffed animals',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What were the only items brought to last year’s Friendsgiving?',
      options: [
        'A turkey and a half eaten pumpkin pie',
        'A keg of beer and cornbread',
        'An apple pie and 500 packets of Liquid I.V.',
        'A turkey and 300 Miller High Life’s',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'What’s the first item on Tucker’s Friendsgiving To-Do List?',
      options: [
        'Make a to-do list',
        'Find vacuum (it’s been a minute)',
        'Toss that moldy toast',
        'Get trash bags (a lot)',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What does Hannah say she loves about Allie’s Brooklyn Thanksgiving?',
      options: [
        'Eating too much apple pie with Allie and then taking a giant nap after',
        'Making up dance routines with Allie and her cousins',
        'Watching Aunt Kathy get drunk and busting out her old cheer routine',
        'Rewatching A Charlie Brown Thanksgiving with Allie',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'When should Tucker start frying the turkey, according to his mom?',
      options: [
        '30 minutes before the guests arrive',
        '45 minutes after he pats it dry',
        'One hour before the sides are ready',
        'Before he starts prepping anything else',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What does Phil want to do when Garrett and Hannah arrive for Thanksgiving dinner?',
      options: [
        'Give Hannah a tour of the house',
        'Watch a hockey game on TV',
        'Help Cindy set the table for dinner',
        'Watch Garrett’s old hockey highlights',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'At Friendsgiving, Tucker says they have more people at the hockey house than:',
      options: [
        'A Walmart on a Black Friday',
        'Times Square on New Year’s Eve',
        'A frat darty on Marathon Monday',
        'Fans in the crowd during a playoff game',
      ],
      correctIndex: 0,
    },
  ],
  6: [
    {
      prompt: 'What is Allie afraid that being in love will get in the way of?',
      options: [
        'Moving to LA',
        'Taking a show to Edinburgh',
        'Working her ass off on Broadway',
        'All of the above',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'What does Dexter text Allie while she’s with Dean?',
      options: [
        'Where are u?',
        'I’m soooooooo drunk rn',
        'i just walked by sean he looked rly sad',
        'Did you have fun at karaoke?',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What did Beau Maxwell skip his midterm for?',
      options: [
        'To see Aaron Tveit in Moulin Rouge',
        'To see Jack Wolfe in Hadestown',
        'To see Jonathan Groff in Merrily We Roll Along',
        'To see Jeremy Jordan in The Great Gatsby',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What name does Allie’s Aunt Kathy go by now?',
      options: [
        'Kate',
        'Kirstin',
        'Kiara',
        'Kyla',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What artist’s work does Dean say his family usually has, but is on loan to The Whitney at the moment?',
      options: [
        'Frank Stella',
        'Jean-Michel Basquiat',
        'Andy Warhol',
        'Keith Haring',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What is the “Yellow Haze” according to Justin?',
      options: [
        'The aura of falling in love',
        'The mystery of a crush',
        'The uncertainty of a new relationship',
        'The intrigue of a situationship',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'At the fundraiser, Logan refers to Garrett as GHA. What does GHA stand for?',
      options: [
        'Great Hockey Athlete',
        'Giant Human Attitude',
        'Grumpy Hockey Addict',
        'General Hard Ass',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'When Dean starts his announcement at the fundraiser, how much money did he say they already raised for the Lil ‘Canes?',
      options: [
        '$1,000',
        '$2,000',
        '$3,000',
        '$4,000',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What is the fundraiser’s theme?',
      options: [
        'Old Hollywood',
        'Hockey Legends',
        'Y2K',
        'Winter Wonderland',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'Who does Dean announce wins first place for one of the fundraiser games?',
      options: [
        'Hunter Davenport',
        'Allie Hayes',
        'Grace Ivers',
        'Sabrina James',
      ],
      correctIndex: 2,
    },
  ],
  7: [
    {
      prompt: 'Hannah uses what excuse to get her dad to drive her to Dairy Queen after a high school hockey game?',
      options: [
        'An international band emergency',
        'Their tradition is to celebrate the team’s hockey wins with a sweet treat',
        'She needs fuel to write her new song',
        'Her clarinet broke',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'How many games was St. Anthony’s hockey team’s winning streak before playing Briar U?',
      options: [
        '6 games',
        '8 games',
        '9 games',
        '10 games',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'Why was Joanna Maxwell visiting Briar U?',
      options: [
        'To get lunch with Beau',
        'To teach a master class for the senior drama students',
        'To film a scene for a new movie she’s working on',
        'To reconnect with one of her old drama professors',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What theme was Hannah’s advisor exploring with his piano piece?',
      options: [
        'The melancholy of children growing up',
        'The emptiness of time',
        'The joys of parenthood',
        'The nostalgia of childhood',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What’s the score of the game after the second period?',
      options: [
        'Vipers - 3, Hawks - 1',
        'Vipers - 2, Hawks - 1',
        'Vipers - 2, Hawks - 0',
        'Vipers - 1, Hawks - 0',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What TV universe does Allie say the name “Carter St. James” sounds like it’s from?',
      options: [
        'Gilmore Girls',
        'Gossip Girl',
        'Glee',
        'Sex And The City',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'Which team has more shots on goal at the end of the third period?',
      options: [
        'Hawks',
        'Vipers',
        'They have equal shots on goal',
        'The shots on goals were disqualified after Garrett was ejected',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What game are Hannah’s parents playing when she calls her mom?',
      options: [
        'UNO',
        'Poker',
        'Euchre',
        'Pinochle',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What is Aaron Delaney’s, the Vipers’s star center forward, jersey number?',
      options: [
        '44',
        '29',
        '22',
        '15',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What’s the first thing Hannah tells Garrett to accomplish to get out of a funk during the game?',
      options: [
        'Stop playing like shit',
        'Get his head in the game',
        'Focus on what matters',
        'Block out all distractions',
      ],
      correctIndex: 0,
    },
  ],
  8: [
    {
      prompt: 'What is the breakup playlist that Hannah and Garrett are both listening to called?',
      options: [
        'i miss my ex',
        'Heartbreak Mix',
        'brb wallowing',
        'crying and screaming',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'What does Hannah offer to the table of guys who request to move sections at Malones?',
      options: [
        'An extra side of fries',
        'A slice of cake on the house',
        'A slice of pie on the house',
        'All of the above',
      ],
      correctIndex: 2,
    },
    {
      prompt: 'When Sean comes to Malone’s, he tells Hannah that he misses Della’s fries. What does Hannah say she misses?',
      options: [
        'Sharing fries with Garrett at Malone’s',
        'Tucker’s salmon',
        'Tucker’s pasta salad',
        'Seeing Sean and Allie together',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What was the Hawks’ hockey record before they were ordered to forfeit all games?',
      options: [
        '13 wins, 3 losses, and 1 tie',
        '10 wins, 5 losses, and 2 ties',
        '11 wins, 4 losses, and 2 ties',
        '14 wins, 2 losses, and 1 tie',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What is the name of the hockey player Dean said he would help train to replace Birdie on the team?',
      options: [
        'Hunter Davenport',
        'Joe Rogers',
        'Carter St. James',
        'Levi Toms',
      ],
      correctIndex: 1,
    },
    {
      prompt: 'What car light does Jules tell Logan came on first while he’s fixing the truck?',
      options: [
        'The squiggly one',
        'The front left one',
        'The back right one',
        'The red one',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'How did Beau know that Dean was hooking up with Allie?',
      options: [
        'Dean told him at Malone’s',
        'He accidentally saw one of their text exchanges on Dean’s phone',
        'Joanna told him',
        'He was in the car with them for eight hours and he has eyes',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'Who scores the winning shot against Eastwood?',
      options: [
        'John Logan',
        'John Tucker',
        'Dean Di Laurentis',
        'Ted Stuber',
      ],
      correctIndex: 0,
    },
    {
      prompt: 'What cover does Dean use for how he found out Hannah was performing in the pop showcase?',
      options: [
        'Allie texted him',
        'Hannah texted him',
        'He had a gut feeling',
        'Beau overheard it in the stands',
      ],
      correctIndex: 3,
    },
    {
      prompt: 'Who won the pop showcase?',
      options: [
        'Hannah',
        'Bethany',
        'Deborah',
        'Aidan',
      ],
      correctIndex: 1,
    },
  ],
};
